module.exports = __webpack_public_path__ + "/images/ico-nav-heart.cc44b6d.svg";